"use strict";
exports.__esModule = true;
var React = require("react");
var ReactDOM = require("react-dom");
var SimpleForm_1 = require("./simple_component/page/front/search_page/components/PresentSearch/SimpleForm");
// 実行
$(function () {
    // 後でやり方は検討
    if (document.getElementById("react-search-simple-form-app")) {
        ReactDOM.render(React.createElement(SimpleForm_1.SimpleForm), document.getElementById("react-search-simple-form-app"));
    }
});
